import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/base.css'
import store from './store'
import {
    api
} from '@/require/api'
import {
    testBaseURL,
    baseURL
} from '@/require/auth'
import vueJsonp from 'vue-jsonp'
import echarts from "echarts";
// element-ui 按需引入
import {
    Form,
    FormItem,
    Input,
    Button,
    Select,
    Option,
    Pagination,
    Message,
    MessageBox,
    Carousel,
    CarouselItem,
    Table,
    TableColumn,
    Popover
} from 'element-ui';
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Popover);
Vue.prototype.$message = Message;
Vue.prototype.$api = api;
Vue.prototype.$testBaseURL = testBaseURL;
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$echarts = echarts
Vue.use(VueCookies)
Vue.use(vueJsonp)

new Vue({
        render: h => h(App),
        router,
        store
    }).$mount('#app')
    // 刷新调用埋点
if (LogCollection) {
    LogCollection.end()
}